import { createSelector } from "reselect"

import reverseTranslateCreator from "./reverseTranslateCreator"

const translationsSelector = state => state.translations

const reverseTranslateSelector = createSelector(
  [translationsSelector],
  translations => reverseTranslateCreator(translations),
)

export default reverseTranslateSelector
